// Currently, the user can easily select seven days before and after an anomaly which amounts to fiften days.
export const MAXIMUM_DATA_POINTS = 15 * 24;
